export default "/images/vendor/flag-icon-css/flags/4x3/tc.svg?c817f550f47380234387a6efa779e0d7";